import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable()
export class EventiService {
  private resourceUrl = environment.apiUrl + 'event';

  constructor(private http: HttpClient) {
  }

  getEvent(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/header');
  }

  getEventDetail(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id);
  }

  getCompetitions(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/competition');
  }

  getAllEvents(): Observable<any> {
    return this.http.get<any>(this.resourceUrl);
  }

  create(request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, request);
  }

  createCompetition(idEvento: number, request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/' + idEvento + '/competition', request);
  }

  removeCompetition(id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/competition/' + id);
  }

  duplicateCompetition(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/competition/duplicate/' + id);
  }

  requestApprovation(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/request');
  }

  accept(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/accept');
  }

  reject(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/reject');
  }

  save(id: any, request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/' + id, request);
  }

  sendToConi(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/coni');
  }
  sendToSS(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/ss/all');
  }

  sedToConiAll(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + id + '/coni/all');
  }

  deleteEvento(id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/' + id);
  }

  deleteEventoConi(id: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/coni/' + id);
  }

  getAllegati(id: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/attachment/' + id);
  }

  saveAllegati(file: File, fileType: number, id: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', fileType + '');
    return this.http.post<any[]>(this.resourceUrl + '/attachment/' + id, formData, {observe: 'response'});
  }

  deleteAllegato(id: number, type: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/attachment/' + id + '/' + type);
  }

  duplicate(idSportEvent: number): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/duplicate/' + idSportEvent);
  }

}



// WEBPACK FOOTER //
// ./src/app/servizi/eventi/eventi.service.ts